<template>

  <div class="theatre-container">
    <button style="display: none" class="test-click" v-on:click="clearAll()"></button>
		<!--<div class="theatre theatre-over" v-if="$store.state.performanceOver" style="color: red; text-align: center; font-size: 40px; text-transform: uppercase;">-->
    <div class="theatre theatre-over" v-if="$store.state.performanceOver && !festivalOverrideActive" style="color: red; text-align: center; font-size: 40px; text-transform: uppercase;">
      Izvedba je završena
    </div>
    <!--<div class="theatre theatre-front" v-if="$store.state.theatreLoaded && !$store.state.performanceOver">-->
    <div class="theatre theatre-front" v-if="$store.state.theatreLoaded && (!$store.state.performanceOver || festivalOverrideActive)">
      <div class="theatre-seats" v-if="!isFormVisible">
				<div class="theatre-livestream" v-if="$store.state.theatre.is_live">
					Livestream :
					<button class="btn btn-black" v-on:click="createTransaction(true)">Kupi live stream ulaznicu</button>
					<span class="live-price">{{ formatCurrency(Math.round($store.state.theatre.live_price)) }}</span>
				</div>
        <ul class="theatre-legend">
          <li v-for="category, key in $store.state.categories" :class="'c-'+key" v-if="key != 0"><span>{{ key }}</span>{{ formatCurrency(category.price) }} </li>
          <li class="c-disabled"><span>0</span>Zauzeto</li>
        </ul>
        <ul class="theatre-note" v-if="[ 1373, 1367, 1379, 1381, 1384, 1386, 1387, 1388, 1389, 1394, 1391, 1393, 1398, 1399, 1400, 1401, 1404, 1421, 1409, 1410, 1412, 1413, 1415, 1418, 1420].includes($store.state.theatre.id)">
          <li>Ulaz uz EU digitalnu COVID potvrdu</li>
        </ul>
        <ul class="theatre-note" v-if="[1096, 1097, 1098, 1099, 1100, 1110, 1102, 1103, 1104, 1105, 1106, 1111, 1108, 1109, 1112, 1113].includes($store.state.theatre.id)">
          <li>Centralne lože od 8 lijevo do 8 desno mezanin i kat kupuju se isključivo u kompletu od 5 ulaznica</li>
          <li>Sva ostala sjedala se kupuju u kompletu od 2 ulaznice</li>
          <li>Pojedinačna sjedala raspoloživa su u parketu (4 mjesta) i balkonu (4 mjesta)</li>
        </ul>
        <p class="theatre-note" v-if="[1312, 1323, 1327, 1328].includes($store.state.theatre.id)">
          Prodaja ulaznica za predstave u sastavu FSK će se prodavati u punom kapacitetu uz predočenje važeće EU digitalne COVID potvrde o cijepljenju, testiranju i/ili preboljenju bolesti COVID-19P
        </p>
        <p class="theatre-note" v-if="[1814].includes($store.state.theatre.id)">
          Ulaznice u 1. i 2. kategoriji sjedenja prodaju se isključivo u paru i uključuju prigodan dar kazališta.
        </p>
        <p class="theatre-note" v-if="[2622, 2623, 2624, 2625, 2626, 2644, 2660, 2664, 2665, 2714].includes($store.state.theatre.id)">
          Napomena: Nenumerirana sjedala, ulaznicu kupuje svaki gledatelj bez obzira na dob
        </p>
        <p class="theatre-note" v-if="[2715, 2716, 2717, 2710, 2791, 2790, 2799, 2800, 2810, 2813, 2814, 2815, 2816, 2817, 2818, 2829, 2819, 2830, 2820, 2821, 2822, 2831, 2823, 2832, 2824, 2825, 2826, 2833, 2827, 2828, 2834, 2827, 2828, 2834, 2840, 2868, 2869, 2870, 2871, 2872, 2873, 2874, 2875, 2876, 2903, 2904, 2905, 2906, 2916, 2922, 2923, 2924, 2969, 2970, 2971, 2954, 2970, 3033, 3025, 3026, 3051, 3052, 3097, 3117, 3118, 3119, 3120, 3136, 3137, 3138, 3139, 3140, 3157, 3158, 3159, 3174, 3175, 3184, 3185, 3169, 3200, 3222, 3223, 3224].includes($store.state.theatre.id)">
          Napomena: Nenumerirana sjedala
        </p>
        <p class="theatre-note" v-if="!$store.state.isTheatre">
		Napomena: Za prvu izvedbu iz Vašeg paketa pretplate zadržavamo mogućnost promjene mjesta sjedenja, zbog istodobne prodaje ulaznica u slobodnoj prodaji.
	</p>
	<p class="theatre-note" v-if="[2721, 2725, 2727, 2729, 2733, 2735, 2744].includes($store.state.theatre.id)">Jedna osoba može kupiti maksimalno 5 ulaznica.</p>
  <p class="theatre-note" v-if="[2204, 2738, 2723].includes($store.state.theatre.id)">Jedna osoba može kupiti maksimalno 2 ulaznice.</p>
        <div class="theatre-seats-holder">
          <SvgPanZoom :zoomEnabled="false" :center="true" :fit="true" :zoomScaleSensitivity="0.5" :panEnabled="false" v-on:svgpanzoom="registerSvgPanZoom" :beforePan="beforePan" :dblClickZoomEnabled="false" :maxZoom="8" :minZoom="1" :controlIconsEnabled="false">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -5 550 490" preserveAspectRatio="xMidYMid meet">
              <Row v-for="(row, rowID) in $store.state.theatre.rows" :model="{id: rowID, row: row}"/>
            </svg>
          </SvgPanZoom>
        </div>
        <div class="zoom-buttons">
          <button v-on:click="changeZoomLevel($event, 'zoom-in')">+</button>
          <button v-on:click="changeZoomLevel($event, 'zoom-out')">-</button>
        </div>
      </div>

      <div class="theatre-book-info" v-else>
        <h3 class="back-button" v-on:click="abortTransaction();">Povratak na odabir sjedala</h3>
        <form class="theatre-form">
          <h2>Molimo ispunite podatke</h2>
          <p class="disclaimer" v-if="!$store.state.isTheatre">
            Hrvatsko narodno kazalište u Zagrebu osobne podatke unesene u donji obrazac obrađuje u svrhu upisa
            pretplate u kazališnoj sezoni 2025/2026 i slanja obavijesti o predstavama i drugim događanjima te ih
            čuva godinu dana. Kako biste upisali pretplatu te osigurali ulaznice za željene predstave unesite
            tražene podatke. Vaši osobni podaci kod nas su sigurni. Više o tome pročitajte u Pravilima o
            privatnosti.
          </p>
          <p v-else class="disclaimer">
						<span style="color: red">Napomena: </span></br>Ukoliko ne primite Vašu ulaznicu za predstavu/live stream u roku od 30 minuta, molimo Vas da nas kontaktirate na mail: blagajna@hnk.hr ili na broj tel. 01/4888-415<br/>
            Kupnjom ulaznice prihvaćate naša Pravila o privatnosti. Više o tome pročitajte na <a href="https://www.hnk.hr/hr/pravne-info/pravila-o-privatnosti/">www.hnk.hr/hr/pravne-info/pravila-o-privatnosti/</a>
          </p>
          <div v-for="user, i in userData" class="form-item">
            <div v-if="!$store.state.isTheatre">
              <h3 v-if="i == 0">Nositelj pretplate</h3>
              <h3 v-if="i > 0">
                Pretplatnik
                <button class="js-remove-subscriber" v-on:click.prevent="removeSubscriber(i)">
                  <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
                </button>
              </h3>
            </div>
            <h3 v-else>Kontakt podaci</h3>
            <label>Ime</label>
            <input v-model="user.first_name" type="text">
            <label class="error-label" :class="validate(user, 'first_name')">Ovo polje je obavezno</label>

            <label>Prezime</label>
            <input v-model="user.last_name" type="text">
            <label class="error-label" :class="validate(user, 'last_name')">Ovo polje je obavezno</label>


            <label>Adresa</label>
            <input v-model="user.address" type="text">
            <label class="error-label" :class="validate(user, 'address')">Ovo polje je obavezno</label>


            <label>Grad</label>
            <input v-model="user.city" type="text">
            <label class="error-label" :class="validate(user, 'city')">Ovo polje je obavezno</label>


            <label>Poštanski broj</label>
            <input v-model="user.postal_code" type="text">
            <label class="error-label" :class="validate(user, 'postal_code')">Ovo polje je obavezno</label>


            <label>Broj telefona</label>
            <input v-model="user.phone" type="text">


            <label>Broj mobitela</label>
            <input v-model="user.mobile_phone" type="text">
            <label class="error-label" :class="validate(user, 'mobile_phone')">Ovo polje je obavezno</label>


            <label>Broj poslovnog telefona</label>
            <input v-model="user.work_phone" type="text">

            <label>Email</label>
            <input v-model="user.email" type="email">
            <label class="error-label" :class="validate(user, 'email')">Ovo polje je obavezno</label>

          </div>
          <button class="btn btn-black" v-on:click.prevent="addSubscriber" v-if="userData.length <= getSelectedSeats.length - 1 && !$store.state.isTheatre">
            Dodaj pretplatnika
          </button>
        </form>
      </div>

      <div :class="`theatre-sidebar ${sidebarClass} sticky`">
  <h3 class="sidebar-title">Vaša sjedala <span v-if="getSelectedSeats.length > 0">({{ getSelectedSeats.length }})</span></h3>
  <h3 class="sidebar-title sidebar-title-mobile">
    <span v-if="getSelectedSeats.length == 0 && !isLive" class="centered">
      Molimo odaberite sjedala
    </span>
    <span v-else>Vaša sjedala <span>({{ getSelectedSeats.length }})</span></span>
    <button class="btn btn-black" v-if="getSelectedSeats.length > 0 && !isFormVisible" v-on:click="createTransaction()">Nastavi kupovinu</button>
    <button class="btn btn-black" v-if="isFormVisible" v-on:click="validateForm">Kupi ulaznice</button>
  </h3>
  <button v-on:touchstart="toggleSidebar()" class="js-collapse" v-if="getSelectedSeats.length > 0">
    <svg fill="#FFF" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/>
      <path d="M0-.5h24v24H0z" fill="none"/>
    </svg>
  </button>
  <div v-if="getSelectedSeats.length == 0 && !isLive">
    <span class="transaction-error" v-if="$store.state.errors.length > 0" v-for="error in $store.state.errors">
      {{ error }}
    </span>
    Molimo odaberite sjedala u planu gledališta
  </div>
  <div v-else class="selected-tickets">
    <div class="item" v-if="isLive">
      <h4>
        Live stream
        <span>
          {{ formatCurrency($store.state.theatre.live_price) }}
        </span>
      </h4>
    </div>
    <div class="item" v-for="seat in getSelectedSeats" :key="seat.id">
      <h4>
        {{ seat.row.title }}
        <span>
          {{ formatCurrency(seat.price) }}
          <button class="js-remove" v-on:click="toggleSeatState([seat.rowID, seat.seatID])" :disabled="isFormVisible">
            <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
          </button>
        </span>
      </h4>
      <p>{{ seatInfo(seat) }}</p>
      <p v-if="checkVisibility(seat.rowID + '-' + seat.seatID)">
        Ograničena vidljivost!
      </p>
    </div>
    <div class="promo-code" v-if="!([1725, 1724, 1737, 1726, 1727, 1728, 1729, 1739, 1730, 1731, 1732, 1733, 1734, 1735, 1740, 1736, 1750, 1751, 1752, 1814, 2188, 2189, 2191, 2195, 2196, 2197, 2199, 2201, 2202, 2203, 2205, 2206, 2207, 2208, 2209].includes($store.state.theatre.id))">
      <label>Promo kod:</label>
      <input v-model="promoCode" placeholder="Ovdje unesi promo kod" v-bind:class="{valid: $store.state.promoCode}" max="10" name="promoCode"/>
    </div>
    <p class="tickets-sum">Ukupno <span>{{ formatCurrency(getFullPrice(false)) }} <span class="discount" v-if="$store.state.promoCode !== undefined && 'uses' in $store.state.promoCode && $store.state.promoCode.uses > 0">-{{$store.state.promoCode.amount}}%</span></span></p>
    <button class="btn btn-black" v-if="!isFormVisible" v-on:click="createTransaction()">Nastavi kupovinu</button>
    <button class="btn btn-black" v-else v-on:click="validateForm">Kupi ulaznice</button>
    <p v-if="isFormVisible" style="color: #fff; margin: 30px 0 -20px; text-align: center;">Kupnja ulaznica je završena u trenutku kada dobijete e-mail s računom, popisom mjesta koja ste kupili i QR kodovima</p>
  </div>
</div>

  <div :class="'seat-info ' + $store.state.seatInfoVisiblity" :style="'transform: translate('+ $store.state.hoverBoxPosition.x + 'px, '+ $store.state.hoverBoxPosition.y +'px)'">
    <div v-if="$store.state.hoveredSeat != null">
      <button class="js-close" v-on:click="$store.state.seatInfoVisiblity = 'is-hidden'">
      <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
     </button>
      <h3>{{ $store.state.hoveredSeat.row.title }}</h3>
      <table>
        <tbody>
          <tr>
            <td>Pozicija</td>
            <td>{{ $store.state.hoveredSeat.orientation }}</td>
          </tr>
          <tr>
            <td>{{ $store.state.hoveredSeat.row.position }}</td>
            <td>{{ $store.state.hoveredSeat.rowNumber }}</td>
          </tr>
          <tr>
            <td>Sjedalo</td>
            <td>{{ $store.state.hoveredSeat.seatID }}</td>
          </tr>
        </tbody>
      </table>
      <span :class="'c-name c-' + $store.state.hoveredSeat.category">{{ formatCurrency($store.state.hoveredSeat.price) }}</span>
      <p v-if="$store.state.hoveredSeat.isBox">
        NAPOMENA<br>Ulaznicu za prednje sjedalo lože nije moguće kupiti bez stražnjeg sjedala!
      </p>
      <p v-if="checkVisibility($store.state.hoveredSeat.rowID + '-' + $store.state.hoveredSeat.seatID)">
        Ograničena vidljivost!
      </p>
      <button class="btn btn-black" v-on:click="selectSeat" v-if="$store.state.hoveredSeat.status == 'available'">
        {{ getButtonText() }}
      </button>
    </div>
  </div>
</div>
<span v-if="!$store.state.theatreLoaded" class="js-loading active">Loading</span>
</div>
</template>


<script>
import { mapGetters } from 'vuex';
import FormatCurrency from '../../mixins/format-currency';

export default {
  name: 'Theatre',
  data() {
    return {
      debounceTimer: null,
      svgpanzoom: null,
      isFormVisible: false,
      isLive: false,
      promoCode: '',
      windowWidth: 0,
      sidebarClass: '',
      userData: [{
        index: 0,
        city: '',
        email: '',
        phone: '',
        address: '',
        last_name: '',
        first_name: '',
        work_phone: '',
        postal_code: '',
        mobile_phone: '',
      }],
      requiredFields: ['first_name', 'last_name', 'city', 'address', 'postal_code', 'mobile_phone', 'email'],
      isSubmitted: false,
      errors: null,
      nowServerTs: null,
    };
  },

  mounted() {
    // Grab server time once via Date header (fallback to client time if not available)
    fetch('/', { method: 'HEAD', cache: 'no-store' })
      .then(function(res) {
        var h = res.headers.get('Date');
        if (h) {
          this.nowServerTs = new Date(h).getTime();
          // Optional: comment this out in prod
          console.log('[FestivalOverride] Server Date header:', h, '-> ms:', this.nowServerTs);
        } else {
          // Optional: comment this out in prod
          console.warn('[FestivalOverride] No Date header found; falling back to client time.');
        }
      }.bind(this))
      .catch(function(err) {
        // Optional: comment this out in prod
        console.warn('[FestivalOverride] Failed to read server time; using client time.', err);
      });
  },

  mixins: [FormatCurrency],

  computed: {
    ...mapGetters([
      'getFullPrice',
      'theatreLoaded',
      'getSelectedSeats',
      'checkPromoCode',
      'isSeatInfoVisible',
    ]),

    isSpecificPlay() {
      const specificPlayIds = [2622, 2623, 2624, 2625, 2626];
      return specificPlayIds.includes(this.$store.state.theatre.id);
    },

    nowTs() {
      return (this.nowServerTs !== null && this.nowServerTs !== undefined)
        ? this.nowServerTs
        : Date.now();
    },

    // Keep buy UI until 21:00 Europe/Zagreb for IDs 3119/3120 (regardless of day)
    festivalOverrideActive() {
      var id = (this.$store && this.$store.state && this.$store.state.theatre)
        ? this.$store.state.theatre.id
        : undefined;

      if (!(id === 3119 || id === 3120)) {
        //console.log('[FestivalOverride] for current performance: false');
        return false;
      }

      // Current HR time as "HH:MM"
      var now = new Date(this.nowTs);
      var fmtTime = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Zagreb',
        hour: '2-digit', minute: '2-digit', hour12: false
      });
      var nowTimeStr = fmtTime.format(now);

      var active = (nowTimeStr < '21:00');
      //console.log('[FestivalOverride] for current performance:', active);

      return active;
    },
  },

  methods: {
    clearAll() {
      for (let row in this.$store.state.theatre.rows) {
        for (let seat in this.$store.state.theatre.rows[row].seats) {
          this.$store.state.theatre.rows[row].seats[seat].status = 'selected';
          let seatToSelectObject = { seatID: seat, rowID: row };
          this.$store.state.selectedSeats.push(seatToSelectObject);
        }
      }
    },

    registerSvgPanZoom(svgpanzoom) {
      this.svgpanzoom = svgpanzoom;
    },

    toggleSidebar() {
      if (this.sidebarClass == '') {
        this.$store.state.seatInfoVisiblity = 'is-hidden';
        this.sidebarClass = 'is-active';
      } else this.sidebarClass = '';
    },

    getButtonText() {
      if (this.$store.state.hoveredSeat.status == 'selected') return 'Odznači sjedalo';
      else return 'Odaberi sjedalo';
    },

    selectSeat() {
      this.$store.dispatch('toggleSeatState', [this.$store.state.hoveredSeat.rowID, this.$store.state.hoveredSeat.seatID]);
      this.$store.state.seatInfoVisiblity = 'is-hidden';
    },

    beforePan(oldPan, newPan) {
      let gutterWidth = 100;
      let gutterHeight = 100;
      let sizes = this.svgpanzoom.getSizes();
      let leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth;
      let rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom);
      let topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight;
      let bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom);
      let customPan = {};
      customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
      customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y));

      return customPan;
    },

    changeZoomLevel(e, type) {
      if (type == 'zoom-in') this.svgpanzoom.zoomIn();
      else this.svgpanzoom.zoomOut();

      let zoomLevel = this.svgpanzoom.getZoom().toFixed(2);

      if (zoomLevel < 1.2) {
        this.svgpanzoom.center();
        this.svgpanzoom.disablePan();
      } else this.svgpanzoom.enablePan();
    },

    toggleSeatState(data) {
      this.$store.dispatch('toggleSeatState', data);
      if (this.$store.getters.getSelectedSeats.length == 0) this.isFormVisible = false;
    },

    addSubscriber() {
      this.userData.push({
        index: this.userData.length,
        city: '',
        email: '',
        phone: '',
        address: '',
        last_name: '',
        first_name: '',
        work_phone: '',
        postal_code: '',
        mobile_phone: '',
      });
    },

    removeSubscriber(index) {
      this.userData.splice(index, 1);
    },

    validate(item, property) {
      let className = '';
      if (this.isSubmitted) {
        if (property == 'email') {
          if (item[property] == '' || item[property].indexOf('@') < 0) {
            className = 'error';
          } else {
            className = 'no-errors';
          }
        } else {
          if (item[property] == '') {
            className = 'error';
          } else {
            className = 'no-errors';
          }
        }

        return className;
      }
    },

    validateForm() {
      this.isSubmitted = true;
      let passed = true;
      this.userData.forEach((user) => {
        for (let key in user) {
          if (this.requiredFields.includes(key) && this.validate(user, key) == 'error') {
            passed = false;
          }
        }
      });

      if (passed) {
        this.setTransactionDetails();
      }
    },

    //Nenumerirana sjedala - Prikazivanje na WEBU kod kupnje 
    seatInfo(seat) {
      const specificPlayIds = [2622, 2623, 2624, 2625, 2626, 2644, 2660, 2664, 2665, 2710, 2715, 2716, 2791, 2790, 2799, 2800, 2810, 2813, 2814, 2815, 2816, 2817, 2818, 2829, 2819, 2830, 2820, 2821, 2822, 2831, 2823, 2832, 2824, 2825, 2826, 2833, 2827, 2828, 
      2834, 2840, 2868, 2869, 2870, 2871, 2872, 2873, 2874, 2875, 2876, 2903, 2904, 2905, 2906, 2916, 2922, 2923, 2924, 2969, 2970, 2971, 2954, 2970, 3033, 3025, 3026, 3051, 3052, 3097, 3117, 3118, 3119, 3120, 3136, 3137, 3138, 3139, 3140, 3157, 
      3158, 3159, 3174, 3175, 3184, 3185, 3169, 3200, 3222, 3223, 3224];
      if (specificPlayIds.includes(this.$store.state.theatre.id)) {
        return 'Nenumerirano sjedalo';
      } else {
        const orientationLabel = seat.orientation || 'Desno'; //fallback na 'desno'
        return `${orientationLabel} / ${seat.row.title || seat.row} / Sjedalo ${seat.seatID || seat.number}`;
        
        //return `Desno / ${seat.row.title || seat.row} / Sjedalo ${seat.seatID || seat.number}`;
      }
    },

    //Validacija posebno po predstavi i po promo kodu 
    validatePromoCode() {
      if (!this.promoCode) {
        return true; // Validation passes if the promoCode is empty
      }
      if (this.$store.state.theatre.id === 2804) {
        if (this.promoCode !== 'NEPROCJENJIVO25') {
          return false; 
        }
      }
      return true;
    },

    async createTransaction(live = false) {

      if (!this.validatePromoCode()) {
        return;
      }

      this.sidebarClass = '';
      let context = {};
        if (live) {
          context = {
            'status': 'online_checkout',
            'amount': this.$store.state.theatre.live_price,
            'seat_updates': {
              'status': 'live_stream',
              'seats': ['live'],
            },
            'kind': 'live-performance'
          };
          this.isLive = true;
        } else {
          // Collect the correct seat data
          const seats = this.$store.getters.getSeatWithRow.map(seat => {
            return seat;
        });

        context = {
          'seat_updates': {
            'status': 'online_checkout',
            'seats': seats,
          },
          'status': 'online_checkout',
          'amount': this.$store.getters.getFullPrice(false),
        };
      }

      if (this.$store.state.promoCode) {
        context['promoCode'] = this.$store.state.promoCode.code;
      }

      if (this.$store.state.isTheatre) {
        context['performance'] = this.$store.state.theatre.id;
      } else {
        context['subscription'] = this.$store.state.theatre.id;
        context['pricelist_id'] = this.$store.state.receivedData.pricelists.list[0].id;
      }

      // Log za transaction info
      // console.log('Transaction context:', JSON.stringify(context, null, 2));

      try {
        await this.$store.dispatch('createTransaction', { context });
        console.log(this.$store.state.errors.length == 0);
        if (this.$store.state.errors.length == 0) {
          this.isFormVisible = true;
        } else {
          this.isFormVisible = false;
        }
      } catch (error) {
        console.error('Error creating transaction:', error);
        // Log the error response for further inspection
        if (error.response && error.response.data) {
          console.error('Server response:', JSON.stringify(error.response.data, null, 2));
        }
      }
    },

    setTransactionDetails() {
      let userData = [];
      let context = {
        'seats': this.$store.getters.getSeatWithRow,
        'subscriber_data': userData,
      };

      if (this.isLive) {
        context['seats'] = ['live'];
        context['kind'] = 'live-performance';
      }

      this.userData.forEach((user, index) => {
        if (index == 0) user.holder = true;
        userData.push(user);
      });

      if (this.$store.state.isTheatre) context['performance'] = this.$store.state.theatre.id;
      else context['subscription'] = this.$store.state.theatre.id;
      this.$store.dispatch('updateTransaction', { context });
    },

    checkVisibility(seat) {
      let visibilitySeats = ['lb-l-2-1', 'lb-l-2-2', 'lb-l-2-3', 'lb-l-3-1', 'lb-l-3-2', 'lb-l-3-3', 'lb-l-3-4', 'lb-r-2-1', 'lb-r-2-2', 'lb-r-2-3', 'lb-r-3-1', 'lb-r-3-2', 'lb-r-3-3', 'lb-r-3-4', 'm-l-1-3', 'm-l-1-4', 'm-l-1-5', 'm-r-1-3', 'm-r-1-4', 'm-r-1-5', 'k-l-1-3', 'k-l-1-4', 'k-l-1-5', 'k-r-1-3', 'k-r-1-4', 'k-r-1-5', 'm-l-2-3', 'm-l-2-4', 'm-l-2-5', 'm-r-2-3', 'm-r-2-4', 'm-r-2-5', 'k-l-2-3', 'k-l-2-4', 'k-l-2-5', 'k-r-2-3', 'k-r-2-4', 'k-r-2-5', 'm-l-3-3', 'm-l-3-4', 'm-l-3-5', 'm-r-3-3', 'm-r-3-4', 'm-r-3-5', 'k-l-3-3', 'k-l-3-4', 'k-l-3-5', 'k-r-3-3', 'k-r-3-4', 'k-r-3-5', 'm-l-4-3', 'm-l-4-4', 'm-l-4-5', 'm-r-4-3', 'm-r-4-4', 'm-r-4-5', 'k-l-4-3', 'k-l-4-4', 'k-l-4-5', 'k-r-4-3', 'k-r-4-4', 'k-r-4-5', 'm-l-5-3', 'm-l-5-4', 'm-l-5-5', 'm-r-5-3', 'm-r-5-4', 'm-r-5-5', 'k-l-5-3', 'k-l-5-4', 'k-l-5-5', 'k-r-5-3', 'k-r-5-4', 'k-r-5-5'];
      let balkonIDs = [1989, 1992, 1991, 1986, 1986];
      if (balkonIDs.includes(this.$store.state.theatre.id)) {
        if (["b-l", "b-r"].includes(seat.substring(0, 3))) {
          return true;
        }
      }

      if (visibilitySeats.includes(seat)) {
        return true;
      } else {
        return false;
      }
    },

    abortTransaction() {
      this.isFormVisible = false;
      let context = {
        'seat_updates': {
          'status': 'available',
          'seats': this.$store.getters.getSeatWithRow,
        },
        'status': 'aborted',
      };

      if (this.$store.state.isTheatre) context['performance'] = this.$store.state.theatre.id;
      else context['subscription'] = this.$store.state.theatre.id;

      this.$store.dispatch('updateTransaction', { context });
    },
  },
  
  watch: {
    festivalOverrideActive: function (val) {
      console.log('[FestivalOverride] for current performance:', val);
    },
    
    promoCode(newValue) {
      //Problematicni promo kodovi - dodati tu
      const validPromoCodes = ['1PLUS1HNK24', '1PLUS1HNK24 ', ' 1PLUS1HNK24', ' 1PLUS1HNK24 '];

      if (validPromoCodes.includes(newValue)) {
        this.promoCode = 'HNK1PLUS124';
      }

      let context = {
        'promoCode': this.promoCode || newValue
      };
      this.$store.dispatch('checkPromoCode', { context });
    },
    getSelectedSeats(newValue) {
      //console.log("Updated selected seats:", newValue); // Debugging
      this.$forceUpdate(); // Ensures that the component re-renders
      //console.log("From theatre.vue...");
      //console.log("Component seats:", this.getSelectedSeats);
      //console.log("Vuex store seats:", this.$store.state.selectedSeats);

    },
  },

};
</script>




<style lang="scss">
  .transaction-error{
    display: block;
    margin-bottom: 18px;
    background-color: #910f13;
    padding: 10px 5px;
  }

  .selected-tickets .item .js-remove{
    &[disabled="disabled"], &:disabled{
      color: #ddd;
      cursor: default;
      &:hover{
        color: #ddd;
      }
    }
  }

  .theatre-note {
    margin-bottom: 30px;
    margin-top: -45px;
    background: lightgray;
    padding: 10px;
    list-style-position: inside;
    text-align: center;

    li {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Theatre/Theatre.vue